import React from 'react';
import PropTypes from 'prop-types';
import CharacterCounter from './CharacterCounter';
import WordCounter from './WordCounter';

const TextCounter = ({ text, showWordCount, maxWords, maxChars }) => {
    return (
        <div>
            {
                (showWordCount || maxWords > 0) ?
                    <WordCounter text={text} maxWords={maxWords} /> :
                    null
            }

            <CharacterCounter text={text} maxChars={maxChars} />
        </div>
    );
};

TextCounter.propTypes = {
    text: PropTypes.string.isRequired,
    showWordCount: PropTypes.bool.isRequired,
    maxWords: PropTypes.number.isRequired,
    maxChars: PropTypes.number.isRequired,
};

export default TextCounter;
